// Generated by CoffeeScript 1.11.1
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/alert',['require','backbone'],function(require) {
  var Alert, View;
  View = require('backbone').View;

  /**
  	Generates a alert message.
  
  	@class Alert
  	@example
  		alert = new Alert("Oops!", "You have an error!", "error")
  		alert.fadeInTime = 1
  		alert.hideDelayTime = 0 // do not hide
  		alert.render()
   */
  return Alert = (function(superClass) {
    extend(Alert, superClass);

    function Alert() {
      this.closeButtonClickHandler = bind(this.closeButtonClickHandler, this);
      this.destroy = bind(this.destroy, this);
      this.hide = bind(this.hide, this);
      return Alert.__super__.constructor.apply(this, arguments);
    }

    Alert.prototype.events = {
      'click .close_button': "closeButtonClickHandler"
    };

    Alert.prototype.id = "alert";


    /**
    		The headline to display in alert
    
    		@property headline
    		@type String
    		@default null
     */

    Alert.prototype.headline = null;


    /**
    		The subhead to display in alert
    
    		@property subhead
    		@type String
    		@default null
     */

    Alert.prototype.subhead = null;


    /**
    		The message to display in alert
    
    		@property message
    		@type String
    		@default null
     */

    Alert.prototype.message = null;


    /**
    		The type of alert eg: error, warning, success, info
    
    		@property type
    		@type String
    		@default "success"
     */

    Alert.prototype.type = "success";


    /**
    		The number of seconds the alert will remain on the screen.
    
    		@property fadeInTime
    		@type Number seconds until the alert hides
    		@default .6
     */

    Alert.prototype.fadeInTime = .6;


    /**
    		The number of seconds the alert will be visible.
    		A value of 0 will not hide alert.
    
    		@property hideDelayTime
    		@type Number seconds until the alert hides
    		@default 3
     */

    Alert.prototype.hideDelayTime = 3;

    Alert.prototype.initialize = function(headline, message, type) {
      this.headline = headline;
      this.message = message;
      if (type) {
        return this.type = type;
      }
    };


    /**
    		Creates a alert element with alert and adds it to the dom
    
    		@method render
    		@return {Object}
     */

    Alert.prototype.render = function() {
      var $closeIcon, $iconWrapper;
      $("#alert").remove();
      $iconWrapper = $('<div>').addClass("icon-wrapper").append(this.getDisplayIcon());
      $closeIcon = $('<span>').addClass("icon icon-x close_button");
      this.$el.addClass(this.type).append($iconWrapper).append($("<h3>").html(this.headline)).append($("<h4>").html(this.subhead)).append($('<p>').addClass('alert-message').html(this.message)).append($closeIcon);
      $("body").append(this.$el);
      return this.$el.fadeIn(this.fadeInTime * 1000, this.hide);
    };

    Alert.prototype.setHeadline = function(headline) {
      if (headline == null) {
        headline = this.headline;
      }
      this.headline = headline;
      if (this.headline) {
        return this.$el.find("<h3>").html(this.headline);
      }
    };

    Alert.prototype.setSubhead = function(subhead) {
      if (subhead == null) {
        subhead = this.subhead;
      }
      this.subhead = subhead;
      if (this.subhead) {
        return this.$el.find("<h4>").html(this.subhead);
      }
    };

    Alert.prototype.setMessage = function(message) {
      if (message == null) {
        message = this.message;
      }
      this.message = message;
      if (this.message) {
        return this.$el.find("p.alert-message").html(this.message);
      }
    };

    Alert.prototype.getDisplayIcon = function() {
      var $icon, className;
      $icon = $('<span>').addClass("icon");
      className = (function() {
        switch (this.type) {
          case 'error':
            return 'x';
          case 'warning':
            return 'exclamation';
          case 'success':
            return 'check';
          case 'info':
            return 'info';
          default:
            return this.type;
        }
      }).call(this);
      return $icon.addClass("icon-" + className);
    };


    /**
    		Hides the alert
    
    		@method hide
     */

    Alert.prototype.hide = function() {
      if (this.hideDelayTime > 0 && this.$el) {
        return this.$el.delay(this.hideDelayTime * 1000).slideUp(100, (function(_this) {
          return function() {
            _this.destroy();
            return _this.$el = null;
          };
        })(this));
      }
    };


    /**
    		removes the alert form the dom
    
    		@method destroy
     */

    Alert.prototype.destroy = function() {
      if (this.$el) {
        this.$el.off();
        return this.$el.remove();
      }
    };

    Alert.prototype.closeButtonClickHandler = function(e) {
      e.preventDefault();
      return this.destroy();
    };

    return Alert;

  })(View);
});

